import { render, staticRenderFns } from "./SearchTableFinewineCase.vue?vue&type=template&id=2194cce2&"
import script from "./SearchTableFinewineCase.vue?vue&type=script&lang=js&"
export * from "./SearchTableFinewineCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports